// extracted by mini-css-extract-plugin
export default {"allMarkets":"styles_allMarkets__Iv7+h","allMarkets__link":"styles_allMarkets__link__bZibC"};